import { z } from 'zod';
export const organizationProfileSchema = z.object({
    name: z.string().min(1).max(160),
    organizationType: z.string().min(1).max(200),
    realWorldAnalogues: z.string().min(1).max(1000),
    mission: z.string().min(1).max(2000),
    approximateScale: z.string().min(1).max(1000),
    desiredFuture: z.string().min(1).max(3000),
    activities: z.string().min(1).max(3000),
    geographicScope: z.string().max(1000).optional(),
    serves: z.string().max(1500).optional(),
    likelyAllies: z.string().max(1500).optional(),
    likelyOpponents: z.string().max(1500).optional(),
    additionalContext: z.string().max(3000).optional(),
});
export const organizationCommandSchema = z.object({
    expectedTeamVersion: z.number().int().nonnegative(),
    archetypeId: z.string().optional(),
    profile: organizationProfileSchema,
    confirm: z.boolean().default(false),
});
export const organizationViewSchema = organizationProfileSchema.extend({
    teamId: z.string(),
    version: z.number().int().nonnegative(),
    confirmed: z.boolean(),
    confirmedAt: z.string().datetime().optional(),
    archetypeId: z.string().optional(),
});
export const organizationArchetypeSchema = z.object({
    id: z.string(),
    label: z.string(),
    description: z.string(),
    defaults: organizationProfileSchema.partial(),
});
//# sourceMappingURL=organization.js.map